// store/slices/locationSlice.ts
import LocationService from '@/services/locations';
import { createSlice, createAsyncThunk, PayloadAction } from '@reduxjs/toolkit';

export interface Location {
  id: string;
  name: string;
  mpath: any;
  parent_id?: string;
  mapping_id?: string;
  children?: any;
  gdm_customer_number: string;
}

interface LocationState {
  data: Location[] | null;
  loading: boolean;
  error: string | null;
  selectedSiteId: string | null; // Track which site these locations belong to
}

const initialState: LocationState = {
  data: null,
  loading: false,
  error: null,
  selectedSiteId: null,
};

// Async thunk for fetching locations based on site
export const fetchLocationsByGdmNumber = createAsyncThunk<
  LocationState,
  { gdmNumber: string; userGuid: string; accessToken?: string }
>(
    'location/fetchLocationsByGdmNumber', async ({gdmNumber, userGuid, accessToken}) => {
    
    const serviceObj = new LocationService(userGuid, gdmNumber, undefined, accessToken);
    const apiResponse = await serviceObj.getAllByGdmNumber();

    return apiResponse?.results || [];
  }
);

const locationSlice = createSlice({
  name: 'location',
  initialState,
  reducers: {
    clearLocations: (state) => {
      state.data = null;
      state.error = null;
      state.selectedSiteId = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchLocationsByGdmNumber.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchLocationsByGdmNumber.fulfilled, (state, action) => {
        const payload = action.payload as any;
        state.loading = false;
        state.data = payload as Location[];
        // state.selectedSiteId = action.payload.siteId;
      })
      .addCase(fetchLocationsByGdmNumber.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message || 'Failed to fetch locations';
      });
  },
});

export const { clearLocations } = locationSlice.actions;
export default locationSlice.reducer;